import { CarhirewebMangalicaV1MangalicaService } from '@skyscanner-internal/mangalica-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

export const GRPC_MANGALICA_GET_PRICES_FOR_SPAN_CLIENT_NAME = 'MANGALICA_GET_PRICES_FOR_SPAN';
export const PATH_PREFIX = '/g/mangalica';

export const getPricesForSpan = grpcFetchClientWrapper(
  CarhirewebMangalicaV1MangalicaService.MangalicaService.GetPricesForSpan,
  {
    clientName: GRPC_MANGALICA_GET_PRICES_FOR_SPAN_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
  },
);
